import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { FreePlanExtendComponent } from './free-plan-extend.component';



@NgModule({
  declarations: [FreePlanExtendComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [FreePlanExtendComponent]
})
export class FreePlanExtendModule { }

